import { AlertTriangle } from "lucide-react";
import { Component, type ReactNode } from "react";

interface Props {
  titolo: string;
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Confina il crash di un singolo widget alla sua card: mostra uno stato d'errore
 * azionabile senza far sparire il resto della dashboard (SPEC-A §9.4).
 */
export class WidgetErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <section className="rounded-xl border border-destructive/30 bg-destructive/5 p-5">
          <div className="flex items-start gap-2 text-sm">
            <AlertTriangle className="mt-0.5 size-4 shrink-0 text-destructive" />
            <div>
              <p className="font-medium text-foreground">{this.props.titolo}</p>
              <p className="text-xs text-muted-foreground">
                Questo widget non è disponibile al momento. Prova ad aggiornare la
                dashboard tra poco.
              </p>
            </div>
          </div>
        </section>
      );
    }
    return this.props.children;
  }
}
